import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const CakeOptionsForm = ({
  sizes,
  flavors,
  colors,
  selectedSize,
  setSelectedSize,
  selectedFlavor,
  setSelectedFlavor,
  selectedColor,
  setSelectedColor,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        // mt: 2,
        px: 2,
        mb: 4,
        flexGrow: 1,
        gridTemplateColumns: "1fr",
      }}>
      {/* Size Selection */}
      {sizes.length > 0 && (
        <FormControl fullWidth>
          <InputLabel>Size</InputLabel>
          <Select
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
            renderValue={(selectedId) => {
              const selectedSizeObj = sizes.find(
                (size) => size._id === selectedId
              );
              return selectedSizeObj ? selectedSizeObj.displayName : "";
            }}>
            {sizes.map((size) => (
              <MenuItem key={size._id} value={size._id}>
                {size.displayName} (up to {size.servings} servings - $
                {size.price})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Flavor & Color Selection */}
      {(flavors.length > 1 || colors.length > 1) && (
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns:
              flavors.length > 1 && colors.length > 1 ? "1fr 1fr" : "1fr",
          }}>
          {flavors.length > 1 && (
            <FormControl fullWidth>
              <InputLabel>Flavor</InputLabel>
              <Select
                value={selectedFlavor}
                onChange={(e) => setSelectedFlavor(e.target.value)}>
                {flavors.map((flavor) => (
                  <MenuItem key={flavor._id} value={flavor._id}>
                    {flavor.displayName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {colors.length > 1 && (
            <FormControl fullWidth>
              <InputLabel>Color</InputLabel>
              <Select
                value={selectedColor}
                onChange={(e) => setSelectedColor(e.target.value)}>
                {colors.map((color, index) => (
                  <MenuItem key={index} value={color}>
                    {color}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CakeOptionsForm;
